import { type BrokersRequiredPaymentInfo } from 'utils/web_api.schemas'

type ResultsTableProps = {
  error?: string
  isLoading: boolean
  results: BrokersRequiredPaymentInfo[]
}

const ResultsTable = ({ error, isLoading, results }: ResultsTableProps) => {
  if (isLoading) {
    return (
      <div className='flex justify-center items-center py-8'>
        <div className='text-gray-500'>Loading results...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className='p-4 bg-red-50 border border-red-200 rounded-lg'>
        <div className='text-red-800 font-medium'>Error loading results</div>
        <div className='text-red-600 text-sm mt-1'>{error}</div>
      </div>
    )
  }

  if (results.length === 0) {
    return (
      <div className='flex justify-center items-center py-8'>
        <div className='text-gray-500'>No results found. Try adjusting your query parameters.</div>
      </div>
    )
  }

  return (
    <div className='space-y-4'>
      <div className='text-sm text-gray-600'>
        Found {results.length} payment{results.length === 1 ? '' : 's'}
      </div>

      <div className='overflow-x-auto'>
        <table className='min-w-full divide-y divide-gray-200'>
          <thead className='bg-gray-50'>
            <tr>
              <th className='px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                Enrollment ID
              </th>
              <th className='px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                Member Name
              </th>
              <th className='px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                Member ID
              </th>
              <th className='px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                Employer Name
              </th>
              <th className='px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                Carrier Name
              </th>
              <th className='px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                Payment Method
              </th>
              <th className='px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                Through Month
              </th>
              <th className='px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider'>
                Amount Due
              </th>
            </tr>
          </thead>
          <tbody className='bg-white divide-y divide-gray-200'>
            {results.map((result) => (
              <tr key={result.enrollment_id} className='hover:bg-gray-50'>
                <td className='px-4 py-3 whitespace-nowrap text-sm text-gray-900'>
                  {result.enrollment_id}
                </td>
                <td className='px-4 py-3 whitespace-nowrap text-sm text-gray-900'>
                  {result.member_name}
                </td>
                <td className='px-4 py-3 whitespace-nowrap text-sm text-gray-900'>
                  {result.member_id}
                </td>
                <td className='px-4 py-3 whitespace-nowrap text-sm text-gray-900'>
                  {result.employer_name}
                </td>
                <td className='px-4 py-3 whitespace-nowrap text-sm text-gray-900'>
                  {result.carrier_name}
                </td>
                <td className='px-4 py-3 whitespace-nowrap text-sm text-gray-900'>
                  {result.payment_method}
                </td>
                <td className='px-4 py-3 whitespace-nowrap text-sm text-gray-900'>
                  {result.through_month}/{result.through_year}
                </td>
                <td className='px-4 py-3 whitespace-nowrap text-sm text-right text-gray-900'>
                  {result.amount_due.formatted_amount}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default ResultsTable
